import { useEffect, useRef, useState } from 'react';

export function captionPlacement(rect, viewport, panel, dock = false) {
  const margin = 14, gap = 18, width = Math.min(panel.width || 340, viewport.width - margin * 2), height = panel.height || 190;
  const clamp = (value, low, high) => Math.max(low, Math.min(value, high));
  const bottom = { x: viewport.width - width - margin, y: Math.max(margin, viewport.height - height - margin), docked: true };
  if (!rect || dock || viewport.width < 760) return bottom;
  const midY = clamp((rect.y + rect.bottom - height) / 2, margin, viewport.height - height - margin);
  if (viewport.width - rect.right >= width + gap + margin) return { x: rect.right + gap, y: midY, docked: false };
  if (rect.x >= width + gap + margin) return { x: rect.x - width - gap, y: midY, docked: false };
  const x = clamp((rect.x + rect.right - width) / 2, margin, viewport.width - width - margin);
  if (viewport.height - rect.bottom >= height + gap + margin) return { x, y: rect.bottom + gap, docked: false };
  if (rect.y >= height + gap + margin) return { x, y: rect.y - height - gap, docked: false };
  return bottom;
}

// Follow changing layout/scroll positions without snapping or restarting the motion.
export function useSoftSpotlight(target, reduced = false) {
  const position = useRef(null);
  const [rect, setRect] = useState(null);
  useEffect(() => {
    if (!target) { position.current = null; setRect(null); return; }
    if (!position.current || position.current.step !== target.step || reduced) { position.current = target; setRect(target); return; }
    let frame, previous = performance.now();
    const move = now => {
      const alpha = 1 - Math.exp(-Math.min(40, Math.max(1, now - previous)) / 95);
      previous = now;
      const next = { step: target.step }, current = position.current;
      let remaining = 0;
      for (const key of ['x', 'y', 'right', 'bottom', 'radius']) {
        next[key] = current[key] + (target[key] - current[key]) * alpha;
        remaining = Math.max(remaining, Math.abs(next[key] - target[key]));
      }
      position.current = remaining < .3 ? target : next;
      setRect(position.current);
      if (remaining >= .3) frame = requestAnimationFrame(move);
    };
    frame = requestAnimationFrame(move);
    return () => cancelAnimationFrame(frame);
  }, [target, reduced]);
  return rect;
}
